/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../connect/v2/resources/error';
import './invoice/invoice-service';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "Status": {
            "fields": {
              "localizedTitle": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "localizedDescription": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "success": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "extOrdersError": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 10000,
                "rule": "optional"
              },
              "extInvoicesStatus": {
                "type": "squareup.client.invoice.Status",
                "id": 10001,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
});

/**
 * The status required for server responses to mobile clients.
 * Should not be used for service to service error messages.
 *
 * SOURCE Status @ squareup/client/status.proto at 18:1
 */
export const Status = $root.lookupType('squareup.client.Status');
fixType(Status, {
  success: { required: true },
});
Builder.createAndAttachToType(Status);
